import Link from "next/link"
import cn from "classnames"
import { getStoryblokLink } from "utilities/getStoryblokLink"
import richText from "utilities/richText"

export default function MiniCard({ heading, content, link, link_label, background_color }) {
  return (
    <div
      className={cn("mini-card relative z-10 flex flex-col justify-between rounded-10", {
        "bg-umber-mid text-white": background_color === "umber-mid",
        "bg-aqua-mid text-white": background_color === "aqua-mid",
        "bg-moss-mid text-white": background_color === "moss-mid",
        "bg-evergreen text-white": background_color === "evergreen",
        "bg-stone-light text-evergreen": background_color === "stone-light",
        "bg-white text-evergreen": background_color === "white",
      })}
    >
      <div className="flex h-full flex-col justify-between p-8">
        <div>
          {heading && <h2 className="mb-2.5 text-l1 lg:text-l2">{heading}</h2>}
          <div>{richText(content)}</div>
        </div>
        {link && link_label ? (
          <Link
            href={getStoryblokLink(link)}
            className={cn("block pt-5 text-m1 font-bold underline hover:no-underline")}
          >
            {link_label}
          </Link>
        ) : null}
      </div>
    </div>
  )
}
